import styled from "styled-components";

export const Price = styled.div`
  margin-top: 10px;
  margin-left: 20px;
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 30px;
`;
